import { createAction, props } from '@ngrx/store';

export const loadDownloadPayrollInvoices = createAction(
  '[DownloadPayrollInvoice] Load DownloadPayrollInvoices',
  props<{ businessId: string; paymentRunDate: string }>()
);

export const loadDownloadPayrollInvoicesSuccess = createAction(
  '[DownloadPayrollInvoice] Load DownloadPayrollInvoices Success',
  props<{ response: any }>()
);

export const loadDownloadPayrollInvoicesFailure = createAction(
  '[DownloadPayrollInvoice] Load DownloadPayrollInvoices Failure',
  props<{ error: Error | any }>()
);
